import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class WinningDotAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "winningDot",
        STATES: {
            GLOW: "glow",
        },
    };

    constructor() {
        super(WinningDotAnimation.ANIMATION_CONFIG.NAME);
        this.play(WinningDotAnimation.ANIMATION_CONFIG.STATES.GLOW, true);
    }
}



// WEBPACK FOOTER //
// ./src/app/WinningDotAnimation.ts